import {ForwardRefExoticComponent, ReactElement, SVGProps} from "react";
import './PageTitle.scss'

export interface PageTitleProps {
    title : string
    icon?: ReactElement<ForwardRefExoticComponent<Omit<SVGProps<SVGSVGElement>, string | number | symbol>>>;
}

/**
 * Component for showing a page title
 */
export const PageTitle = ({title, icon}: PageTitleProps) =>
{
    return(
        <h1 className="text-secondary d-flex align-items-center m-0 p-0">
            {icon !== undefined &&
                <span className="page-title-icon-background d-inline-flex">
                    <span className="d-inline-flex m-auto page-title-icon-span">
                        {icon}
                    </span>
                </span>
            }
            <span className="me-2"/>{title}
        </h1>
    )
};
